import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import validator from "validator";
import { format } from "date-fns";
import { getGeneralTypes, postData, postDataResponse } from "./Services";
import { StyledSelect, InputContainer, InputWrapper, HeaderContainer, HeaderText, NoteField, GreyButton, RedButton, RightJustifyDiv, SubmitSpan, divOverflowHidden, divFloatLeft, divFloatRight, StyledSelectLeft, StyledSelectRight } from "./Style";
import { useMsal } from "@azure/msal-react";
//import Typography from "@mui/material/Typography";
//import { Grid, TextField, Backdrop, Button, Card, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select, TextareaAutosize } from '@mui/material/';
import { Grid, TextField, Backdrop, Button, Card, CircularProgress, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
//import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
//import Button from '@mui/material/Button';

import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import InputMask from 'react-input-mask';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { TextFields } from "@mui/icons-material";
import ConfirmDialog from "./ConfirmDialog";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const CaseDateForm = ({ onSave, Case = {} }) => {
  const [MatterID, setMatterID] = useState([]);
  const [Type, setType] = useState([]);
  const [errorRequest, setErrorRequest] = useState(false);
  const [selectedValueMatterID, setSelectedValueMatterID] = useState("");
  const [selectedValueType, setSelectedValueType] = useState("");
  const [StartDateTimeVal, SetStartDateTimeVal] = useState(new Date());
  const [EndDateTimeVal, SetEndDateTimeVal] = useState(new Date());
  const [MinDateTimeVal, SetMinDateTimeVal] = useState(new Date());
  const [dateTimeRangeError, setdateTimeRangeError] = useState(false);
  const [notes, setNotes] = useState('');
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState('');
  const { instance } = useMsal();
  const [courtLocation, setCourtLocation] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [dialogMessage, SetDialogMessage] = useState("");
  const [isUploading, setUploading] = useState(false);
  const [dialogDestUrl, setDialogDestUrl] = useState("");

  async function ClearForm() {
    SetEndDateTimeVal(dayjs(new Date()));
    SetStartDateTimeVal(dayjs(new Date()));
    SetMinDateTimeVal(dayjs(new Date()));
    setSelectedValueMatterID("");
    setSelectedValueType("");
    setNotes("");
    setCourtLocation("");
  }

  useEffect(() => {
    async function fetchInitialData(_email) {
      //Matter ID dropdown
      
      const currentAccount = instance.getActiveAccount();
      var body = {};
      if (currentAccount) {
        setUserEmail(currentAccount.username);
        body.email = currentAccount.username;
      }
      const tokenRequest = {
        account: currentAccount, // This is an example - Select account based on your app's requirements
        scopes: ["User.Read"]
      }
      
      const matterIDResponse = await postDataResponse('/User/MatterList', body);  //await getMatterID(body.email);
      matterIDResponse.errors ? setErrorRequest(true) : setMatterID(matterIDResponse.data);
      
      
      //Case Type dropdown
      const TypeResponse = await getGeneralTypes('/Settings/SubmitDateTypes');
      TypeResponse.errors ? setErrorRequest(true) : setType(TypeResponse);

    }

    fetchInitialData();
  }, [instance, userEmail]);

  const handleSelectTypeChange = (event) => {
    setSelectedValueType(event.target.value);
  };

  const handleCourtLocationChange = (event) => {

    setCourtLocation(event.target.value);
  }

  const handleSelectChangeMatterID = (event) => {
    setSelectedValueMatterID(event.target.value);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setUploading(true);

    // Read the form data
    const form = e.target;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());

    let _ctype = formJson.TypeSelect;
    let _mID = formJson.MatterIDSelect;
    let _notes = formJson.txtNotes;

    let _sdtvalue = StartDateTimeVal.toISOString();
    let _edtvalue = EndDateTimeVal.toISOString();//format(EndDateTimeVal, "MM/dd/yyyy HH:mm");
    let postObject = {
      EMail: userEmail,
      MatterID: _mID,
      Type: _ctype,
      StartDateTime: _sdtvalue,
      EndDateTime: _edtvalue,
      CourtLocation: formJson.txtCourtLocation,
      Note: _notes

    };

    postDataResponse('/Matter/SubmitDate', postObject).then((response) => {
      setUploading(false);
      if (response.status === 200 || response.status === 201) {
        setIsSuccess(true);
        SetDialogMessage("Case Date was Successfully Submitted");
      }
      else {
        setIsSuccess(false);
        SetDialogMessage(response.data);
      }
      setUploading(false);
      setOpenDialog(true);
    });
  };

  const handleCloseDialog = () => { setOpenDialog(false); };
  return (

    <form onSubmit={handleSubmit}>
      <div>
        <Card className="form-card">
          <CardHeader title="Case Date" style={{ backgroundColor: "#8B0E04", color: "#fff" }} />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="MatterIDSelectLbl">Matter ID</InputLabel>
                  <Select
                    labelId="MatterIDSelectLbl"
                    id="MatterIDSelect"
                    name="MatterIDSelect"
                    value={selectedValueMatterID}
                    label="Matter ID"
                    onChange={handleSelectChangeMatterID}
                  >
                    <MenuItem value="">Choose a Matter</MenuItem >
                    {<Select.Option value="sample">Sample</Select.Option> !== null ? MatterID.map((value) => (
                      <MenuItem key={value.id} value={value.id}>
                        {"\"" + value.id + "\" - " + value.description + " - " + value.clientSort}
                      </MenuItem >
                    )) : <MenuItem ></MenuItem >}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="TypeLbl">Type</InputLabel>
                  <Select
                    labelId="TypeLbl"
                    id="TypeSelect"
                    name="TypeSelect"
                    value={selectedValueType}
                    label="Type"
                    onChange={handleSelectTypeChange}
                  >
                    <MenuItem value="">Choose a Type</MenuItem >
                    {Type.map((value) => (
                      <MenuItem key={value.Key} value={value.Key}>
                        {value.Value}
                      </MenuItem >
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} item>
                <FormControl fullWidth margin="normal">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="Start Date/Time"
                      name="StartDateTime"
                      id="StartDateTime"
                      onChange={(startDateTimeVal) => { SetStartDateTimeVal(dayjs(startDateTimeVal)); setIsValid(true); SetMinDateTimeVal(dayjs(startDateTimeVal).add(1, 'second')) }}
                      value={dayjs(StartDateTimeVal)}
                      defaultValue={dayjs(StartDateTimeVal)}
                      disablePast
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} item>
                <FormControl fullWidth margin="normal">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="End Date/Time"
                      name="EndDateTime"
                      id="EndDateTime"
                      onChange={(endDateTimeVal) => { SetEndDateTimeVal(dayjs(endDateTimeVal)); setIsValid(true); }}
                      value={dayjs(EndDateTimeVal)}
                      defaultValue={dayjs(EndDateTimeVal)}
                      minDateTime={dayjs(MinDateTimeVal)}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid xs={12} item>
                <TextField onChange={handleCourtLocationChange} label="Court Location" name="txtCourtLocation" id="txtCourtLocation" variant="outlined" margin="normal" fullWidth required placeholder="Enter Court Location" />
              </Grid>
              <Grid xs={12} item>
                <TextField
                  name="txtNotes"
                  label="Notes" variant="outlined" margin="normal"
                  multiline
                  rows={5}
                  maxRows={15}
                  value={notes}
                  onChange={e => setNotes(e.target.value)}
                  required
                  fullWidth
                  placeholder="Notes"

                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button type="submit" variant="contained" style={{ backgroundColor: "rgb(207, 66, 64)" }} sx={{ height: '48px' }} fullWidth>Submit</Button>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button type="reset" variant="contained" style={{ backgroundColor: "rgb(51, 51, 51)" }} sx={{ height: '48px' }} onClick={ClearForm} fullWidth>Clear</Button>
              </Grid>

            </Grid>
          </CardContent>
        </Card>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={isUploading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      <ConfirmDialog
        isOpen={openDialog}
        onClose={handleCloseDialog}
        isSuccess={isSuccess}
        message={dialogMessage}
        destination={dialogDestUrl}
      />
    </form>
  );
};
export default CaseDateForm;
